import {GRANITE_1, GRANITE_7} from '@gaia/colors';
import GaiaIcon from '@gaia/icons/GaiaIcon';
import {MapboxControlButton, MapboxControlGroup} from '@gaia/utils/mapbox/MapboxControl';
import {useIsLegendEnabled, useToggleLegendWithAnalytics} from '@map/Legend/store';
import SubscriptionTooltip from '@map/SubscriptionTooltip';

import classes from './Controls.module.css';

export function LegendControl() {
    const isLegendEnabled = useIsLegendEnabled();
    const toggleLegend = useToggleLegendWithAnalytics();

    return (
        <MapboxControlGroup>
            <MapboxControlButton
                disabled={!isLegendEnabled}
                aria-label='Map Legend'
                className={classes.mapControl}
                onClick={toggleLegend}
            >
                <SubscriptionTooltip
                    subscription={undefined}
                    analyticsContext='legendControl'
                    title={
                        isLegendEnabled
                            ? 'Map Legend'
                            : 'Map Legend preview supports only Gaia Winter'
                    }
                    placement='left'
                >
                    <GaiaIcon
                        name='info-outline'
                        style={{
                            width: 24,
                            height: 24,
                            color: isLegendEnabled ? GRANITE_1 : GRANITE_7,
                        }}
                    />
                </SubscriptionTooltip>
            </MapboxControlButton>
        </MapboxControlGroup>
    );
}
